
import ReactDOM from "react-dom";
import { useNavigate, useParams } from "react-router-dom";
import { useRef, useState, useEffect } from "react";
import PostUpdateConvicton from "./postUpdateConviction"
import { acdCodes } from "../../utils/acdCodes";
import { useAuth } from "../../context/AuthContext.js";
import { buildAddWithdrawal, buildUpdateFcwdDriverInfo, buildUpdateWithdrawalDetails, buildWithdrawalDetails, 
    defaultConvictions, defaultDriverData, defaultWithdrawals, isDown, 
    isNewUser, makeWithdrawalObjectForAdd, postJson, setDefaultDriverData, 
    toYMD } from "../../utils/data";
import { threadCpuUsage } from "process";
import ShowComments from "./showComments.js"

export default function UpdateConviction(){
    const { jurisdiction, license, id, acd, cdl, disable, n} = useParams();
    const [formData, setFormData] = useState({acdCat:defaultConvictions[n].ConvictionCategory, cdlHold:cdl});
    const {source, token, userState, email, roles } = useAuth();
    const [notes, setNotes] = useState(defaultConvictions[0].ConvictionStatusNotes)
    const [errs, setErrs] = useState();
    const [isHovered, setIsHovered] = useState(false); 
    const [comment, setComment] = useState("");
    const saver = useRef(null);
    const warnRef = useRef(null);
    const screenRef = useRef(null);
    const navigate = useNavigate();


    const  handleCancel = (e) => {
        e.preventDefault();
        navigate(-1);
    }

    const handleChange = (event) =>{
        event.preventDefault();
        const { name, value} = event.target;
        setFormData((formData) => ({ ...formData, [name]: value }));
    }

    const handleSubmit = () => {
        let errors = []

        if(formData.acdCat === ""){
            errors.push(<li>Conviction CDL Holder Indicator Required</li>)
        }

        if(formData.cdlHold === ""){
            errors.push(<li>Conviction ACD Category Required</li>)
        }

        if(comment.length < 4){
            errors.push(<li>Please provide comments for the audit file.</li>)
        }

        const today = new Date();
        const formattedDate = today.toLocaleDateString('en-US');
        const formatComment  =  formattedDate + " " + email + " " + comment;


        if(errors.length > 0){
            setErrs(errors)
            return;
        } else {
                const data = 	
        {
            "Header": {
                "Metadata": {
                    "UserID": email,
                }
            },
            "Body": {
                "Source":{
                    "DataSource": source
                },
                "License": {
                    "JurisdictionOfIssue": jurisdiction,
                    "LicenseNumber": license
                },
                "Conviction": {
                    "ConvictionID": id,
                    "ConvictionAcdCategory": formData.acdCat,
                    "ConvictionCDLHolderIndicator": formData.cdlHold,
                    "ConvictionStatusNotes": formatComment
                
                }
            }
        }
    
        

        try {    
            ReactDOM.render(<PostUpdateConvicton data={data} auth={token}/>,
                screenRef.current); 
            } catch(err){
                    alert(err)
            }
        }
    }

    return(
        <div className="App" ref={screenRef}>
            <div style={{color: 'red'}}>{errs}</div>
            <div ref={saver}></div>
                <h1>Update Conviction</h1>
            <hr />
            <div id="table" ref={warnRef}>
                <form
                    className="needs-validation was-validated"
                    id="Index-form"
                    noValidate
                    onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b>Driver State</b>
                                </label>
                                    <input
                                        className="form-control"
                                        type="text"
                                        placeholder="TX"
                                        value={jurisdiction}
                                        disabled={true}
                                    />
                            </div>
                            <div className="col-md-5">
                                <label className="form-label">
                                    <b>Driver License</b>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    placeholder="Test1234"
                                    value={license}
                                    disabled={true}
                                />
                            </div>
                                <div className="col-md-3">
                                    <label className="form-label">
                                        <b>Conviction ID</b>
                                    </label>
                                        <input
                                            className="form-control"
                                            type="text"
                                            value={id}
                                            disabled={true}
                                        />
                                </div>        
                        <hr />
                        <div className="row">
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b><span> </span>Citation Date: </b>
                                </label>
                               <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].CitationDate}
                                    disabled={true}
                                />
                            </div>
                              <div className="col-md-3">
                                <label className="form-label">
                                    <b><span></span>Conviction Date</b>
                                </label>
                                 <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionDate}
                                    disabled={true}
                                />
                                </div>
                                 <div className="col-md-3">
                                <label className="form-label">
                                    <b><span></span>Court Type:</b>
                                </label>
                                 <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionCourtType}
                                    disabled={true}
                                />
                                </div>
                        </div>
                         <div className="row">
                            <div className="col-md-3">
                                <label className="form-label"><b>ACD Details</b></label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        name="acdDetails"
                                        value={defaultConvictions[n].ConvictionOffenseDetailAcd}
                                        disabled={true}
                                    />
                                </div>
                                <div className="col-md-3">
                                <label className="form-label">
                                    <b>CMV</b>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionCommercialVehInd}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-3">
                                 <label className="form-label">
                                    <b>Hazmat</b>
                                </label>
                                  <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionHazmatInd}
                                    disabled={true}
                                />
                            </div>
                            <div className="col-md-3">
                                 <label className="form-label">
                                    <b>SOC</b>
                                </label>
                                   <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].JurisdictionCodeConvicting}
                                    disabled={true}
                                />
                            </div>
                        </div>
                         <div className="row">
                             <div className="col-md-3">
                                 <label className="form-label">
                                    <b>Conviction Offense Locator</b>
                                </label>
                                <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionIdCode}
                                    disabled={true}
                                />
                             </div>
                             <div className="col-md-3">
                                <label className="form-label">
                                    <b>State Native Code</b>
                                </label>
                                 <input
                                    className="form-control"
                                    type="text"
                                    value={defaultConvictions[n].ConvictionJurisdictionOffenseCode}
                                    disabled={true}
                                />
                             </div>
                              {/* <div className="col-md-3">
                                  <label className="form-label">
                                    <b>Comments</b>
                                </label>
                                     <input
                                    className="form-control"
                                    name="notes"
                                    value={notes}  
                                    disabled={true}   
                                    onChange={(e) => setNotes(e.target.value)}
                                    type="text"
                                />
                             </div> */}
                            
                             <hr />
                         </div>

                        <div className="row">
                            <div className="col-md-5">
                                <label className="form-label">
                                    <b>ACD Code</b>
                                </label>
                                   <select
                                    className="form-control form-select"
                                    value={acd}
                                    name="acd"
                                    disabled={true}
                                >
                                    <option value="">
                                        -- ACD Code --
                                    </option>
                                    {acdCodes.map((opt) => (
                                        <option key={opt.code} value={opt.code} title={opt.label}>
                                            {opt.code} - {opt.simple}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            
                             <hr />
                         </div>
                        <div className="row">
                             <div className="col-md-3">
                                  <label className="form-label">
                                    <b>Comments</b>
                                    </label>
                                     <input
                                    className="form-control"
                                    name="comment"
                                    value={comment}     
                                    onChange={(e) => setComment(e.target.value)}
                                    type="text"
                                    required
                                />
                                <div style={{ position: 'relative', display: 'inline-block' }}>
                            <a 
                                onMouseEnter={() => setIsHovered(true)}
                                onMouseLeave={() => setIsHovered(false)}
                                style={{ color: '#0070f3', textDecoration: 'underline', cursor: 'pointer' }}
                            >Past Comments</a>
                                {isHovered && <ShowComments  comments={defaultConvictions[n].ConvictionStatusNotes} />}
                                </div>
                             </div>
                           
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b>Conviction ACD Category</b>
                                </label>
                                   <select
                                    className="form-control form-select"
                                    value={formData.acdCat}
                                    onChange={(e)=> handleChange(e)}
                                    required
                                    name="acdCat"
                                >
                                    <option value="">
                                        -- ACD Category --
                                    </option>
                                    <option value="Major">
                                        Major
                                    </option>
                                    <option value="RRHGC">
                                        RRHGC
                                    </option>
                                    <option value="VOOSO">
                                        VOOSO
                                    </option>
                                    <option value="Serious">
                                        Serious
                                    </option>
                                    <option value="Other">
                                        Other
                                    </option>
                                </select>
                            </div>

                           
                            <div className="col-md-3">
                                <label className="form-label">
                                    <b>Conviction CDL Holder Indicator</b>
                                </label>
                                {disable === "true" ? (
                                    <>
                                <select
                                    className="form-control"
                                    type="text"
                                    name="cdlHold"
                                    required
                                    disabled={disable}
                                    value={formData.cdlHold}
                                    onChange={(e)=> handleChange(e)}
                                >
                                    <option value="1">Yes</option>
                                    <option value="2">No</option>
                                    <option value="9">Unknown</option>
                                </select>    </>                         
                                ) : (        
                                 <>             
                                <select
                                    className="form-control"
                                    type="text"
                                    name="cdlHold"
                                    required 
                                    value={formData.cdlHold}
                                    onChange={(e)=> handleChange(e)}
                                >
                                    <option value="1">Yes</option>
                                    <option value="2">No</option>
                                    <option value="9">Unknown</option>
                                </select> </>
                                )}             
                            </div>
                        </div>
                    </div>
                </form>
                <button type="button" className="btn btn-primary" 
                id="button" form='Index-form' style={{"textAlign": "start"}} 
                onClick={(e) => handleSubmit(e, formData)}
                >Update</button>

                <button type="button" className="btn btn-primary" 
                id="button" form='Index-form' style={{"textAlign": "start"}} 
                onClick={(e) => handleCancel(e)}
                >Back to Details for DL:{license}</button>
            </div>
        </div>
    )
}